export const table = {
  data () {
    return {}
  },
  methods: {
    refreshTable (ref) {
      this.$refs[ref].refresh();
      if (this.modals && this.modals[ref])
      this.modals[ref] = false
    }
  }
};